import { Navigate, Routes, Route, Outlet } from 'react-router-dom'
import { AnonymousMasterLayout } from '../../_metronic/layout/AnonymousMasterLayout'
import ClientRenewal from './components/ClientRenewal'

const SubscriptionRenewalClientPage = () => (
    <Routes>
        <Route element={<AnonymousMasterLayout />}>
            <Route
                element={
                    <>
                        <Outlet />
                    </>
                }
            >
                <Route
                    path="/"
                    element={
                        <>
                            <ClientRenewal />
                        </>
                    }
                />
            </Route>
            <Route path='*' element={<Navigate to='/error/404' />} />
        </Route>
    </Routes>
)

export default SubscriptionRenewalClientPage
